// extracted by mini-css-extract-plugin
export default {"tabs":"AccountTabs_tabs__nq2zk","tab":"AccountTabs_tab__9c4YD","activeTab":"AccountTabs_activeTab__5gX9i"};